/** Copyright © 2025 Qcells. All rights reserved.
This software is proprietary and confidential. Unauthorized use,
duplication, or distribution of software is strictly prohibited.
*/

import { rest } from 'msw';

import { apiWrapper } from '@hems/service/src/util/apiHelper';
import { activityHistoryData } from '@hems/util/src/mocks/data/activityHistoryData';

const API_BASE_URL = process.env.VUE_APP_API_URL;

const ACTIVITY_HISTORY_API_URL = `${API_BASE_URL}${apiWrapper.managerApiV1('/site-activities')}`;

const activityHistoryHandler = rest.get(ACTIVITY_HISTORY_API_URL, (req, res, ctx) => {
  const url = new URL(req.url);
  const activityType = url.searchParams.get('activities');

  if (activityType) {
    const filteredData = activityHistoryData.data.filter((item) => activityType.includes(item.activityType));
    const response = {
      context: {
        ...activityHistoryData.context,
        totalCount: filteredData.length,
      },
      data: filteredData,
    };

    return res(ctx.status(200), ctx.json(response));
  }

  const response = activityHistoryData;

  return res(ctx.status(200), ctx.json(response));
});

export const activityHistoryHandlers = [activityHistoryHandler];
